import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { API } from "../../../../core";
import { ButtonTheme, MethodRequest, PriceDuration } from "../../../../constants";
import { useStores } from "../../../../stores";
import { GrandChartStore } from "../../../../stores/grand-charts/grand-chart.store";

import { ActionsButton, Container, Description, NameProduct, Title } from "./ChoosePlanModal.styled";
import { Button, Modal } from "../../../common";

interface ChoosePlanModalProps {
	grandChart: GrandChartStore;
}

export const ChoosePlanModal = observer(({ grandChart }: ChoosePlanModalProps) => {
	const { stripeStore, settingsStore, authStore, promoCodeStore } = useStores();

	const { t } = useTranslation();
	const navigate = useNavigate();

	const monthGoodStore = grandChart.getPrice(PriceDuration.Monthly);
	const yearlyGoodStore = grandChart.getPrice(PriceDuration.Yearly);

	const isRuPayment = settingsStore.lang === "ru";

	const getCurrencyPrice = (shopGoodStore: typeof monthGoodStore) => {
		if (!shopGoodStore) {
			return "";
		}

		return 1;

		/*if (isRuPayment) {
			return `${shopGoodStore?.price_ruble} ₽`;
		}

		return `$${shopGoodStore.priceFormat}`;*/
	};

	const handleOnBuy = async (shopGoodStore: typeof monthGoodStore) => {
		if (!shopGoodStore) {
			return;
		}

		if (!authStore.isAuth) {
			navigate("/sign/login");
			return;
		}

		/**
		 * RU → Prodamus
		 */
		if (isRuPayment) {
			const link = await API.request<string>("shop/invoice", {
				method: MethodRequest.Post,
				body: API.getFormData({
					shop_good_id: shopGoodStore.id,
					promo_code: promoCodeStore.promoCode,
				}),
			});

			window.open(link, "_blank");

			return;
		}

		/**
		 * Other languages → Stripe
		 */
		/*await stripeStore.redirectPaymentLink({
			shop_good_id: shopGoodStore.id,
		});*/
	};

	const handleOnMonthly = async () => {
		await handleOnBuy(monthGoodStore);
	};

	const handleOnYearly = async () => {
		await handleOnBuy(yearlyGoodStore);
	};

	const isNotShow = grandChart.title.includes("Pre") || grandChart.title.includes("Grand chart");

	return (
		<Modal modalStore={grandChart.choosePlanModal} isShow={grandChart.choosePlanModal.isShow} maxWidth={620}>
			<Container>
				<Title>{t("pricing.choose_plan.title")}</Title>

				<NameProduct>
					{grandChart.instrument.name} | {isNotShow ? "" : grandChart.title}
				</NameProduct>

				<Description>
					<p>{t("pricing.choose_plan.monthly_or_yearly")}</p>
					<p>
						<span>{t("pricing.choose_plan.save_with_annual")}</span>
					</p>
				</Description>

				<ActionsButton>
					{monthGoodStore && (
						<Button theme={ButtonTheme.GRAY} onClick={handleOnMonthly} isLoading={stripeStore.isLoading}>
							{t("pricing.choose_plan.monthly", {
								price: getCurrencyPrice(monthGoodStore),
							})}
						</Button>
					)}

					{yearlyGoodStore && (
						<Button theme={ButtonTheme.GOLD} onClick={handleOnYearly} isLoading={stripeStore.isLoading}>
							{t("pricing.choose_plan.yearly", {
								price: getCurrencyPrice(yearlyGoodStore),
							})}
						</Button>
					)}
				</ActionsButton>
			</Container>
		</Modal>
	);
});
